<router-outlet></router-outlet>

<ng-http-loader [entryComponent]="awesomeComponent"></ng-http-loader>
